export const GET_ALL_SUBSCRIPTION_ORDER = "GET_ALL_SUBSCRIPTION_ORDER";
export const GET_ALL_SUBSCRIPTION_ORDER_SUCCESS =
  "GET_ALL_SUBSCRIPTION_ORDER_SUCCESS";
export const GET_ALL_SUBSCRIPTION_ORDER_ERROR =
  "GET_ALL_SUBSCRIPTION_ORDER_ERROR";
